// extracted by mini-css-extract-plugin
module.exports = {"Item":"BoardGame_Item__3n6zX","Left":"BoardGame_Left__3YVQ-","Right":"BoardGame_Right__U4PJi","Title":"BoardGame_Title__1cp_c","Players":"BoardGame_Players__1bDdi"};